import { Button, Typography } from 'shared';

type TNextSessionFormMiroBoardLinkButton = {
  onClick: () => void;
  children: string;
};

export const NextSessionFormMiroBoardLinkButton = ({
  onClick,
  children,
}: TNextSessionFormMiroBoardLinkButton) => (
  <Button
    onClick={onClick}
    size="xs"
    _focusVisible={{ outline: 'none' }}
    variant="ghost"
    colorPalette="blue"
  >
    <Typography color="blue">{children}</Typography>
  </Button>
);
